import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

import Icon from '../../../../Icon';

import styles from './styles.module.styl';

const MenuList = ({ children, isLoading, ...props }) => {
  return (
    <components.MenuList {...props}>
      {children}

      {isLoading && (
        <div className={styles.loaderWrapper}>
          <Icon name="loader" size={24} className={styles.loader} />
        </div>
      )}
    </components.MenuList>
  );
};

MenuList.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
};
export default memo(MenuList);



// WEBPACK FOOTER //
// ./src/components/common/AsyncPaginatedSelect/components/MenuList/index.jsx